// src/utils/dict.js
// 字典 编码 <-> 汉字。纯函数，字典由调用方传入，不依赖组件 this。

// 编码 → 汉字
export function findNameByCode(code, list) {
    if (!code) return ''
    const item = list.find(item => item.codeValue === code)
    return item ? item.codeName : code // 找不到就返回原编码
}

// 名称 → 编码（原来只有 inWarehouse.vue 有，可一并搬过来）
export function findCodeByName(value, list) {
    if (!value) return ''
    if (list.some(item => item.codeValue === value)) return value
    const item = list.find(item => item.codeName === value)
    return item ? item.codeValue : value
}